let translateStatic = {
	heroTitle: 'Find your home safety!'
};

export default translateStatic;
